module.exports = __webpack_public_path__ + "static/team-messaging-for-shift-work-9aadcca632e1e5c58bfa78b06297d3e3.svg";